import { readTable, writeTable } from 'utils/local-table';
import { AppNotification, LS_KEYS } from './types';

const NOTIFICATION_CAP_PER_USER = 200;

export const newId = (): string => crypto.randomUUID();
export const nowIso = (): string => new Date().toISOString();

export const readNotifications = (): AppNotification[] =>
  readTable<AppNotification>(LS_KEYS.notifications);

export const writeNotifications = (rows: AppNotification[]): void => {
  const byRecipient = new Map<string, AppNotification[]>();
  for (const n of rows) {
    const bucket = n.recipientUserSub ?? `role:${n.recipientRole ?? 'unknown'}`;
    const list = byRecipient.get(bucket) ?? [];
    list.push(n);
    byRecipient.set(bucket, list);
  }

  const capped: AppNotification[] = [];
  for (const list of byRecipient.values()) {
    list.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    capped.push(...list.slice(0, NOTIFICATION_CAP_PER_USER));
  }

  writeTable(LS_KEYS.notifications, capped);
};

// Approval-banner acknowledgements (contract §6 #8 — allowed to stay local).
export const readAcks = (): string[] => readTable<string>(LS_KEYS.acks);

export const addAck = (proposalId: string): void => {
  const acks = readAcks();
  if (acks.includes(proposalId)) return;
  writeTable(LS_KEYS.acks, [...acks, proposalId]);
};
